  <template>

    <div class="tinymce-boxz">
      <el-select v-model="ruleForm.name" placeholder="请选择投诉公司" class="custom-select" popper-class="select-dropdown">
        <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.name" />
      </el-select>
      <!-- <input type="file" @change="handleFileChange" />   -->
      <Editor v-model="ruleForm.desc" :api-key="apiKey" :init="init" />
      <button @mousemove="handleMouseMove1"   @click="this.$emit('update:drawer', false)"  ref="button1" class="gsap-button" style="margin-left: 0px;" @mouseenter="handleMouseEnter1" @mouseleave="handleMouseLeave1" >返回</button>
      <button class="gsap-button" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"   ref="button" @click="handleSubmit">
        提交
      </button>
      <!-- <img v-if="imageUrl" :src="imageUrl" alt="Image Preview"/> -->

    </div>
  </template>

<script>
import Editor from "@tinymce/tinymce-vue";

import { getComplaintList, postComplaint, login, deleteComplaint, getCompanyList, QgetCompanyList, getCompanyIMG } from '@/api/api'
import { reactive, ref, toRefs } from "@vue/reactivity";
import { ElMessage } from 'element-plus'
import { gsap } from "gsap";
import { getToken } from '@/utils/store'

export default {
  name: "About",
  components: {
    Editor,
  },
  data() {
    return {
      enterAngle: 0,
      Complainlist: [],
      drawer: false,
      showComplaint: false, // 确保初始化
      enterAngle: 0, // 用来存储鼠标进入时的角度
      ruleForm: {
        name: "",
        desc: ""
      },
      imgbase64Array: [],  // 用于存储多个 base64 图片字符串
      uploadedImageUrls: [],  // 用于存储上传后的图片 URLs
      imgbase64: '', formData: {},
      imageUrl: '',
      imageFile: null, // The file object
      blobInfo:'',
      username: "13038093674",
      password: "yourpassword123",
      activeStatus: "pending",
      companyList: [],
      hasToken: !!getToken('token'),
      showLoginTip: false,
      stopChecking: false,
      showDeleteConfirm: false,
      showComplaint: false, uploadedFileName: '', // 用于存储上传文件的文件名
      deleteItemId: null,  // 存储要删除的项目ID
      uploadedImageUrl: ''  // 用于保存上传的图片 URL
    } // 用来存储鼠标进入时的角度

  },
  watch: {

  },
  mounted() {

    this.getCompanyListall()
    const token = getToken('token')
    if (token) {
      this.getComplaintList()
    } else {
      // console.log('未登录状态')
    }
    this.getCompanyOptions()
    this.tokenChecker = setInterval(() => {
      this.checkToken()
    }, 1000)
  },
  beforeUnmount() {
    if (this.tokenChecker) {
      clearInterval(this.tokenChecker)
    }

  },
  methods: {

  async getComplaintList() {
      const token = getToken('token')
      if (!token) {
        // console.log('未登录，无法获取投诉列表')
        return
      }

      try {
        const res = await getComplaintList()
        // console.log('投诉列表：', res)
        this.Complainlist = res
      } catch (error) {
        // console.error('获取投诉列表失败：', error)
      }
    },
    checkToken() {
      this.hasToken = !!getToken('token')
      if (!this.hasToken && !this.stopChecking) {
        this.showLoginTip = true
      }
    },
    cancelLogin() {
      this.showLoginTip = false
      this.stopChecking = true
    },
    goToLogin() {
      this.showLoginTip = false
      // 获取全局的 menu 组件并显示登录弹窗
      const menu = document.querySelector('.menu').__vue__
      if (menu) {
        menu.loginDialogVisible = true
      }
    },
    async getCompanyOptions() {
      try {
        const res = await getCompanyList()
      } catch (error) {
        console.error('获取公司列表失败：', error)
      }
    },
    async getCompanyListall() {
      const res = await QgetCompanyList()
      // console.log('公司列表：', res)
      this.companyList = res
    },
    handleSubmit() {
      const token = getToken('token')
      if (!token) {
        ElMessage({
          message: "未登录，请先登录！",
          type: "warning"
        });
        return;
      }

      // 添加输入验证
      if (!this.ruleForm.name.trim() || !this.ruleForm.desc.trim()) {
        ElMessage({
          message: "请确保公司名称和投诉内容不为空！",
          type: "warning"
        });
        return;
      }

      // 去掉 HTML 标签
      // const cleanDesc = this.ruleForm.desc.replace(/<[^>]+>/g, ''); // 使用正则表达式去除 HTML 标签

      try {
        postComplaint({
          company_name: this.ruleForm.name,
          content: this.ruleForm.desc, // 使用处理后的内容
          complaint_type: "TYPE1",
          title: 'ok',
          location: '111',
          // picture: this.uploadedImageUrl,
        });

        this.ruleForm.name = '';
        this.ruleForm.desc = '';
        this.getComplaintList();



        ElMessage({
          message: "提交成功！",
          type: "success"
        });
      } catch (error) {
        ElMessage({
          message: "提交失败，请确保公司名称无误！",
          type: "error"
        });
        this.ruleForm.name = '';
        this.ruleForm.desc = '';
      }



      this.$emit('update:drawer', false); // 触发自定义事件并传递值
    },
    handleMouseEnter(event) {
      const button = this.$refs.button;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标进入按钮时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      this.enterAngle = (angle + Math.PI) / (2 * Math.PI); // 将角度转化为 0-1 的值

      // 将角度转换为 360 度，并使用 GSAP 动画填充颜色
      const angleDeg = this.enterAngle * 360;

      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white,#55A5FA)`, // 根据鼠标角度动态填充背景
        duration: 1.2,
        color: "#808080",
        ease: "power2.out",
        backgroundSize: "200% 200%", // 扩大背景区域
        scaleX: 1.1,
        scaleY: 1.1,

      });
    },
    handleMouseMove(event) {
 

      const button = this.$refs.button;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标在按钮内移动时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      const normalizedAngle = (angle + Math.PI) / (2 * Math.PI); // 转换为 0 到 1 之间的值
      const angleDeg = normalizedAngle * 360; // 将角度转换为 360 度

      // 使用 GSAP 动画平滑更新背景渐变的方向
      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white,#9BDCFF)`, // 根据鼠标的角度动态调整背景
        duration: 1.2, // 动画持续时间，快速响应
        ease: "power2.out",
      });
    },
    handleMouseMove1(event) {


      const button = this.$refs.button1;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标在按钮内移动时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      const normalizedAngle = (angle + Math.PI) / (2 * Math.PI); // 转换为 0 到 1 之间的值
      const angleDeg = normalizedAngle * 360; // 将角度转换为 360 度

      // 使用 GSAP 动画平滑更新背景渐变的方向
      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white, #9BDCFF)`, // 根据鼠标的角度动态调整背景
        duration: 1.2, // 动画持续时间，快速响应
        ease: "power2.out",
      });
    },
    handleMouseLeave() {
      const button = this.$refs.button;

      // 使用 GSAP 动画让颜色沿着原来的路径退出
      gsap.to(button, {
        background: ` #2F80ED `, // 沿着进入时的角度退出
        backgroundSize: "100% 100%", // 恢复背景大小
        color: "white",
        duration: 1.2,
        ease: "power2.out",
        scaleX: 1,
        scaleY: 1,
      });
    },
    handleMouseEnter1(event) {
      const button = this.$refs.button1;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标进入按钮时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      this.enterAngle = (angle + Math.PI) / (2 * Math.PI); // 将角度转化为 0-1 的值

      // 将角度转换为 360 度，并使用 GSAP 动画填充颜色
      const angleDeg = this.enterAngle * 360;

      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white,#808080)`, // 根据鼠标角度动态填充背景
        duration: 1.2,
        color: "#808080",
        ease: "power2.out",
        backgroundSize: "200% 200%", // 扩大背景区域
        scaleX: 1.1,
        scaleY: 1.1,

      });
    }, 
   
    handleMouseLeave1() {
      const button = this.$refs.button1;

      // 使用 GSAP 动画让颜色沿着原来的路径退出
      gsap.to(button, {
        background: ` #2F80ED `, // 沿着进入时的角度退出
        backgroundSize: "100% 100%", // 恢复背景大小
        color: "white",
        duration: 1.2,
        ease: "power2.out",
        scaleX: 1,
        scaleY: 1,
      });
    },
  },
  setup(editor) {
    const content = ref("");

    const tiny = reactive({
      apiKey: "f8gwhxcd4xvg5p5dtb49sajt6o1f9yacxov2tcj67eh4mvv8", 
    //https://github.com/tinymce/tinymce-vue/blob/main/src/demo/views/Iframe.vue
      init: {
        selector: 'textarea', // 替换为你的选择器
        
        language: "zh_CN", //语言类型
        // placeholder: "在这里输入你的投诉内容", //textarea中的提示信息
        min_width: 320,
        min_height: 220,
        content_style: `
          body {
         background:#F8F7FB;
  background-attachment: fixed; /* 使背景在滚动时保持不变 */
  background-size: cover; /* 确保背景覆盖整个区域 */
  padding: 20px; /* 为内容提供足够的内边距 */
  border-radius: 12px; /* 圆角设计，匹配外边框的圆角 */
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加内阴影，营造凹陷效果 */
  color: #333; /* 设置字体颜色为深灰，保持文字清晰度 */
  font-family: "Microsoft YaHei", "Arial", sans-serif; /* 使用现代优雅字体 */
  line-height: 1.6; /* 提高文本行间距，增强可读性 */

        }
  
    img {
      margin: 0px 10px; /* 上下各增加10px的间距 */
      //  width: 200px !important; /* 固定宽度 */
      // height: 150px !important; /* 固定高度 */
      object-fit: cover; /* 保持图片比例并裁剪 */
    }
      
  `,
  setup: (editor) => {
        editor.on('init', () => {
          const editorContainer = document.querySelector('.tox');
          if (editorContainer) {
            // 设置边框为渐变色
            editorContainer.style.border = '8px solid transparent'; // 必须设定透明边框
            editorContainer.style.borderRadius = '8px';
            editorContainer.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
            editorContainer.style.overflow = 'hidden';
            editorContainer.style.backgroundClip = 'padding-box';
            editorContainer.style.borderImage = '#F8F7FB';
           
          }

          const toolbar = document.querySelector('.tox-toolbar');
          if (toolbar) {
            toolbar.style.background = '#F8F7FB';
            toolbar.style.border = 'none';
            toolbar.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.2)';
            // toolbar.style.borderRadius = '2px';
          } 

          const menubar = document.querySelector('.tox-menubar');
          if (menubar) {
            menubar.style.background = '#F8F7FB';
            menubar.style.border = 'none';
          }
        
        });
      },
  
        height: 500, //注：引入autoresize插件时，此属性失效
        resize: "both", //编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号
        branding: false, //tiny技术支持信息是否显示
        // statusbar: false,  //最下方的元素路径和字数统计那一栏是否显示
        // elementpath: false, //元素路径是否显示

        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;", //字体样式
        plugins:
          "print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern autosave emoticons", //插件配置 axupimgs indent2em
        toolbar: [
          'undo redo | bold italic |  image', // 只保留这些按钮
        ], //工具栏配置，设为false则隐藏
        menubar: "false", //菜单栏配置，设为false则隐藏，不配置则默认显示全部菜单，也可自定义配置--查看 http://tinymce.ax-z.cn/configure/editor-appearance.php --搜索"自定义菜单"

        // images_upload_url: '/apib/api-upload/uploadimg',  //后端处理程序的url，建议直接自定义上传函数image_upload_handler，这个就可以不用了
        // images_upload_base_path: '/demo',  //相对基本路径--关于图片上传建议查看--http://tinymce.ax-z.cn/general/upload-images.php
        paste_data_images: true, //图片是否可粘贴
        //此处为图片上传处理函数
        images_upload_handler: (blobInfo, success, failure) => {
          // console.log("====blob=>",blobInfo.blob())
          const file = blobInfo.blob();
  
  // 使用 FileReader 读取图片
  let reader = new FileReader();
  reader.readAsDataURL(file);
  
  reader.onloadend = function () {
    // 创建一个 Image 对象来加载图片
    const img = new Image();
    img.src = reader.result;
    
    img.onload = function () {
      // 创建一个 canvas 元素用于图片压缩
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      const MAX_WIDTH = 200;  // 最大宽度
      const MAX_HEIGHT = 250; // 最大高度
      let width = img.width;
      let height = img.height;

      // 计算新的宽高比，确保宽高不超过最大值
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }

      // 设置 canvas 大小并绘制压缩后的图片
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      
      // 将压缩后的图片转为 base64 格式
      const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8); // 设置压缩比例 0.8 

      // 上传压缩后的图片
      success(compressedBase64); 
    };
    
    img.onerror = function () {
      failure('图片加载失败');
    };
  };

  reader.onerror = function () {
    failure('图片读取失败');
  };
          
          let formData = new FormData()
          formData.append("upload",blobInfo.blob())
          formData.append("CKEditorFuncNum","1")
          getCompanyIMG(formData).then(res=>{
            // console.log(res)
          })
          
        },

        file_picker_types: "file image ", //file image media分别对应三个类型文件的上传：link插件，image和axupimgs插件，media插件。想屏蔽某个插件的上传就去掉对应的参数
        // 文件上传处理函数
        file_picker_callback: function (callback, value, meta) {
          // 使用案例http://tinymce.ax-z.cn/general/upload-images.php
          // meta.filetype  //根据这个判断点击的是什么file image media

          let filetype; //限制文件的上传类型,需要什么就添加什么的后缀
          if (meta.filetype == "image") {
            filetype = ".jpg, .jpeg, .png, .gif, .ico, .svg";
          } else if (meta.filetype == "media") {
            filetype = ".mp3, .mp4, .avi, .mov";
          } else {
            filetype =
              ".pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4, .jpg, .jpeg, .png, .gif, .ico, .svg";
          }
          let inputElem = document.createElement("input"); //创建文件选择
          inputElem.setAttribute("type", "file");
          inputElem.setAttribute("accept", filetype);
          inputElem.click();
          inputElem.onchange = () => {
            let file = inputElem.files[0]; //获取文件信息
            this.uploadedFileName = file.name; // 保存文件名
            // 所有都转成base64文件流,来自官方文档https://www.tiny.cloud/docs/configure/file-image-upload/#file_picker_callback
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
              // Note: Now we need to register the blob in TinyMCEs image blob
              // registry. In the next release this part hopefully won't be
              // necessary, as we are looking to handle it internally.
              let id = "blobid" + new Date().getTime();
              let blobCache = tinymce.activeEditor.editorUpload.blobCache;
              let base64 = reader.result.split(",")[1];
              let blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);

              // call the callback and populate the Title field with the file name
              callback(blobInfo.blobUri(), { title: file.name });
            };
          };
        },
      },
      
    });
    return {
      content,
      ...toRefs(tiny),
    };
  },
};
</script>
<style scoped>
.tinymce-boxz>textarea {
  display: none;
  z-index: 1000;

}

.gsap-button {
  width: 120px;
  height: 36px;
  background:  #55A5FA;
  border-radius: 2px;
  border: 2px solid transparent;
  margin-left: 1100px;
  margin-top: 16px;
  color: white;
  border: none;
  cursor: pointer;

  transition: background-color 0.3s ease, transform 0.3s ease;
}

.gsap-button:focus {
  outline: none;
}

</style>
<style>
/* 隐藏apikey没有绑定当前域名的提示 */
.tox-notifications-container .tox-notification--warning {
  display: none !important;
}

.tox.tox-tinymce {
  max-width: 100%;

}

</style>
